import { Alert, Snackbar, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface SavedPlanScnackbarProps {
  showSnackbar: boolean;
  setShowSnackbar: Dispatch<SetStateAction<boolean>>;
}

export default function SavedPlanSnackbar({
  showSnackbar,
  setShowSnackbar,
}: SavedPlanScnackbarProps) {
  return (
    <Snackbar
      open={showSnackbar}
      autoHideDuration={4000}
      onClose={() => setShowSnackbar(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Alert
        onClose={() => setShowSnackbar(false)}
        severity="success"
        variant="filled"
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: 'primaryLight.contrastText',
          'MuiAlert-action': {
            pt: 0,
          },
        }}
      >
        <Typography color="primaryLight.contrastText" fontWeight={600}>
          Successfully saved plan!
        </Typography>
      </Alert>
    </Snackbar>
  );
}
